import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import Login from "./Pages/Login";
import SignIn from "./Pages/SignIn";
import SignUp from "./Pages/SignUp";
import Partners from "./Pages/Partners";
import Contact from "./Pages/Contact";
import Home2 from "./Pages/Home2";
import CoursesDetails from "./Pages/CoursesDetails";
import Cart2 from "./Pages/Cart2";
import Wishlist from './Pages/Wishlist'
import Checkout2 from "./Pages/Checkout2";
import NewLogin from "./Pages/NewLogin";
import Profile from "./Pages/Profile";
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import ForgotPassword from "./Pages/ForgotPassword.jsx"
import BeATrainer from "./Pages/BeATrainer.jsx";
import GisulServices from "./Pages/GisulServices.jsx";
import CorporateHiring from "./Pages/CorporateHiring.jsx";
import TrainDepoy from "./Pages/TrainDepoy.jsx";
import ClodeLab from "./Pages/ClodeLab.jsx";
import Services2 from "./Pages/Services2.jsx";
import LateralHirning from "./Pages/LateralHirning.jsx";
import HireTrainDepoy from "./Pages/HireTrainDepoy.jsx";
import LMS from "./Pages/LMS.jsx";
import LMS2 from "./Pages/LMS2.jsx";
import { useEffect } from "react";
import Aos from "aos";
import Assessment from "./Pages/Assessment.jsx";
import Work from "./Pages/Work.jsx";
import Privacy from "./Pages/PrivacyPolicy.jsx";
import Terms from "./Pages/Terms.jsx";
import Testimonials from "./Pages/Testimonials.jsx";
import ScrollToTop from "./Components/ScrollToTop.jsx";
import Notification from "./Pages/Notification.jsx";
import Faq from "./Pages/Faq.jsx";
import DiveOur from "./Pages/DiveOur.jsx";
import OurMedia from "./Pages/OurMedia.jsx";
import OurGallery from "./Pages/OurGallery.jsx";
import OurWork from "./Pages/OurWork.jsx";
import OurAwards from "./Pages/OurAwards.jsx";
import WhatClient from "./Pages/WhatClient.jsx";

function App() {
  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true,     // animate only once
    });
  }, []);
  return (
    <>
      <ToastContainer autoClose={1000} />
      <Router>
      <ScrollToTop />
        <Routes>
          <Route path="/MastermindsHQ" element={<Home />} />
          <Route path="/login" element={<SignIn />} />
          <Route path="/forgot" element={<ForgotPassword />} />
          <Route path="/" element={<Login />} />
          <Route path="/WhoWeBe" element={<Login />} />
          <Route path="/notification" element={<Notification />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/newlogin" element={<NewLogin />} />
          <Route path="/singup" element={<SignUp />} />
          <Route path="/BondedBrilliance" element={<Partners />} />
          <Route path="/SayHello" element={<Contact />} />
          <Route path="/course" element={<Home2 />} />
          <Route path="/coursesdetails/:courseId" element={<CoursesDetails />} />
          <Route path="/cart" element={<Cart2 />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/checkout" element={<Checkout2 />} />
          <Route path="/profile" element={<Profile />} />

          {/* ---------------------- Services Pages --------------------- */}
          <Route path="/services" element={<GisulServices />} />
          <Route path="/corporate-hiring" element={<CorporateHiring />} />
          <Route path="/train" element={<TrainDepoy />} />
          <Route path="/cloudlab" element={<ClodeLab />} />
          <Route path="/assessment" element={<Assessment />} />
          <Route path="/lms2" element={<LMS2 />} />  


          {/* ---------------------- Services Pages --------------------- */}



          {/*------------------- This Are Static Pages ---------------------- */}
          <Route path="/beatrainer" element={<BeATrainer />} />

          {/* ---------------------- Community Pages --------------------- */}
          <Route path="/dive-our" element={<DiveOur />} />
          <Route path="/our-media" element={<OurMedia />} />
          <Route path="/our-gallery" element={<OurGallery />} />
          <Route path="/our-work" element={<OurWork />} />
          <Route path="/our-awards" element={<OurAwards />} />
          <Route path="/what-client" element={<WhatClient />} />

          {/* ---------------------- Community Pages --------------------- */}
          
          <Route path="/services2" element={<Services2 />} />
          <Route path="/work" element={<Work />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms&condition" element={<Terms />} />
          <Route path="/testimonials" element={<Testimonials />} />

          <Route path="/lms" element={<LMS />} />  
          {/* lms could be a dynamic */}
          <Route path="/lateralhirning" element={<LateralHirning />} />
          <Route path="/hiretraindepoy" element={<HireTrainDepoy />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
